import React from "react";
import {
  CONNECTIVITY,
  getConnectivity,
  reportBrowserOffline,
  subscribeConnectivity,
} from "../../services/connectivityService";

const PROBLEM_MESSAGES = {
  [CONNECTIVITY.OFFLINE]:
    "You're offline. Changes won't save until your connection returns.",
  [CONNECTIVITY.DEGRADED]:
    "Can't reach the MBOSS API. Retrying in the background…",
};

const RESTORED_MESSAGE = "Connection restored.";
const RESTORED_MS = 3500;

class ConnectivityBanner extends React.Component {
  state = {
    ...getConnectivity(),
    showRestored: false,
  };

  unsubscribe = null;
  previousStatus = getConnectivity().status;
  restoredTimer = null;

  componentDidMount() {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      reportBrowserOffline();
    }

    // Online restore is confirmed by ConnectivityProbe via /system/ping.
    window.addEventListener("offline", this.handleBrowserOffline);

    this.unsubscribe = subscribeConnectivity((next) => {
      const prev = this.previousStatus;
      this.previousStatus = next.status;

      const restored =
        Boolean(prev) &&
        prev !== CONNECTIVITY.ONLINE &&
        next.status === CONNECTIVITY.ONLINE;

      if (restored) {
        this.clearRestoredTimer();
        this.setState({ ...next, showRestored: true });
        this.restoredTimer = window.setTimeout(() => {
          this.restoredTimer = null;
          this.setState({ showRestored: false });
        }, RESTORED_MS);
        return;
      }

      if (next.status !== CONNECTIVITY.ONLINE) {
        this.clearRestoredTimer();
        this.setState({ ...next, showRestored: false });
        return;
      }

      this.setState(next);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("offline", this.handleBrowserOffline);
    this.clearRestoredTimer();
    if (this.unsubscribe) this.unsubscribe();
  }

  clearRestoredTimer = () => {
    if (this.restoredTimer) {
      window.clearTimeout(this.restoredTimer);
      this.restoredTimer = null;
    }
  };

  handleBrowserOffline = () => {
    reportBrowserOffline();
  };

  render() {
    const { status, showRestored } = this.state;

    if (showRestored) {
      return (
        <div
          className="connectivity-banner connectivity-banner--restored"
          role="status"
          aria-live="polite"
        >
          <i className="fa fa-check-circle" aria-hidden />
          <span>{RESTORED_MESSAGE}</span>
        </div>
      );
    }

    const message = PROBLEM_MESSAGES[status];
    if (!message) return null;

    const tone =
      status === CONNECTIVITY.OFFLINE
        ? "connectivity-banner--offline"
        : "connectivity-banner--degraded";

    return (
      <div
        className={`connectivity-banner ${tone}`}
        role="status"
        aria-live="polite"
      >
        <i
          className={
            status === CONNECTIVITY.OFFLINE
              ? "fa fa-plug"
              : "fa fa-exclamation-triangle"
          }
          aria-hidden
        />
        <span>{message}</span>
      </div>
    );
  }
}

export default ConnectivityBanner;
